import Vue from 'vue'
import axios from 'axios'
import SocialSharing from 'vue-social-sharing'
import Waitlist from './Components/waitlist.vue'
import RegistrationForm from './Components/registration-form.vue'
import Throttle from './Components/throttle.vue'
import AccessCode from './Components/access-code.vue'

import { AxiosRedirectIntercepted } from '../Shared/errors'
import {
    trackAddToCart,
    trackBeginCheckout,
    trackShare,
    trackIdle,
} from '../Shared/analytics'

const RESERVATION_FAILED_STATUS = 1

const hasCartExpired = () => {
    var field = 'expired'
    var url = window.location.href
    if (url.indexOf('?' + field + '=') != -1) return true
    else if (url.indexOf('&' + field + '=') != -1) return true
    return false
}

const vm = new Vue({
    el: '#ticket-container',
    data: Object.assign(window.preLoadeddata, {
        pageIndex: 1,
        showModal: false,
        modalTitle: '',
        modalType: 'info',
        modalMessage: '',
        busy: false,
        showNoTicketsSelectedAlert: false,
        showMustPurchaseAdditionalTicketsAlert: false,
        showMustPurchaseAdditionalTicketsAlertMessage: '',
        showExpiredAlert: hasCartExpired(),
        showAddToCalendar: false,
    }),
    components: {
        SocialSharing,
        Waitlist,
        Throttle,
        AccessCode,
        RegistrationForm,
    },
    mounted() {
        setInterval(trackIdle, 60 * 1000)
    },
    watch: {
        // clear an alerts whenever there are changes
        // to requested inventory
        requestedInventory: {
            handler() {
                this.showNoTicketsSelectedAlert = false
                this.showMustPurchaseAdditionalTicketsAlert = false
                ;(this.showMustPurchaseAdditionalTicketsAlertMessage = ''),
                    (this.showExpiredAlert = false)
                this.accessCode.showWarning = false
            },
            deep: true,
        },
    },
    computed: {
        showTotal() {
            return this.anyTicketsSelected
        },

        selectedTickets() {
            return Object.keys(this.requestedInventory)
                .filter(inventoryId => this.requestedInventory[inventoryId] > 0)
                .map(inventoryId => {
                    const quantity = this.requestedInventory[inventoryId]
                    const inventoryItem = this.inventory[inventoryId]

                    return {
                        inventoryId,
                        quantity,
                        name: inventoryItem.name,
                        price: inventoryItem.price,
                        total: inventoryItem.price * quantity,
                        requiresAnyOfTheseInventoriesToBeSelected:
                            inventoryItem.requiresAnyOfTheseInventoriesToBeSelected,
                    }
                })
        },

        requestedInventoryToPost() {
            return this.selectedTickets.reduce((obj, ticket) => {
                obj[ticket.inventoryId] = ticket.quantity
                return obj
            }, {})
        },

        anyTicketsSelected() {
            return this.selectedTickets.length
        },

        total() {
            var total = this.selectedTickets
                .map(ticket => ticket.total)
                .reduce((total, current) => total + current, 0)

            return total
        },

        showNextButton() {
            return this.pageIndex < this.totalNumberOfPages
        },

        showPreviousButton() {
            return this.totalNumberOfPages > 1 && this.showGetTicketsButton
        },

        showGetTicketsButton() {
            return !this.showNextButton
        },
    },
    methods: {
        moveToNextPage() {
            this.pageIndex = this.pageIndex + 1
            const transitionInMs = 500
            setTimeout(() => {
                window.scrollTo(0, 0)
            }, transitionInMs)
        },

        moveToPreviousPage() {
            this.pageIndex = this.pageIndex - 1
            this.showNoTicketsSelectedAlert = false
            this.showMustPurchaseAdditionalTicketsAlert = false
        },

        onSocialShareOpen(network, url) {
            trackShare(network, url)
        },

        showNoTicketsSelectedAlertAndSetFocus() {
            this.showNoTicketsSelectedAlert = true
            this.showExpiredAlert = false
            this.$nextTick(() => this.$refs.noTicketsSelectedAlert.focus())
        },

        showMustPurchaseAdditionalTicketsAlertAndFocus(message) {
            this.showMustPurchaseAdditionalTicketsAlert = true
            this.showMustPurchaseAdditionalTicketsAlertMessage = message
            this.showExpiredAlert = false
            this.$nextTick(() =>
                this.$refs.mustPurchaseAdditionalTicketsAlert.focus(),
            )
        },

        addTicket(inventoryId) {
            const { minimumQuantity, maximumQuantity } = this.inventory[
                inventoryId
            ]
            const currentNumberOfTickets = this.requestedInventory[inventoryId]
            if (this.requestedInventory[inventoryId] < maximumQuantity) {
                const numberOfTicketsToAdd =
                    currentNumberOfTickets == 0 ? minimumQuantity : 1
                this.requestedInventory[inventoryId] += numberOfTicketsToAdd
            }
        },

        removeTicket(inventoryId) {
            const { minimumQuantity, maximumQuantity } = this.inventory[
                inventoryId
            ]
            const currentNumberOfTickets = this.requestedInventory[inventoryId]
            if (this.requestedInventory[inventoryId] != 0) {
                const numberOfTicketsToRemove =
                    currentNumberOfTickets == minimumQuantity
                        ? minimumQuantity
                        : 1
                this.requestedInventory[inventoryId] -= numberOfTicketsToRemove
            }
        },

        isRemoveDisabled(inventoryId) {
            return this.requestedInventory[inventoryId] == 0
        },

        isAddDisabled(inventoryId) {
            return (
                this.requestedInventory[inventoryId] ==
                this.inventory[inventoryId].maximumQuantity
            )
        },

        activeClass(inventoryId) {
            return this.requestedInventory[inventoryId] > 0 ? 'active' : ''
        },

        showOnCurrentPage(inventoryId) {
            return this.inventory[inventoryId].pageToShowOn == this.pageIndex
        },

        redirectToPage(redirectTo) {
            window.location = redirectTo
        },

        handleReservationFailure() {
            this.showModalDialog(
                'Tickets are reserved',
                'The ticket(s) you requested are currently reserved by other customers. Try selecting a smaller number of tickets, a different ticket type or try again later.',
            )
        },

        handleError(error) {
            if (error instanceof AxiosRedirectIntercepted) return

            console.error('Something went wrong', error)

            this.showModalDialog(
                'Something went wrong',
                'Oops! Something went wrong. Wanna try again?',
            )
        },

        showModalDialog(title, message) {
            this.showModal = true
            this.modalTitle = title
            this.modalMessage = message
        },

        showAddToCalendarDialog() {
            this.showAddToCalendar = true
            document.body.className += ' ' + 'modal-open'
        },

        closeAddToCalendarDialog() {
            window.location.reload(true)
        },

        showBusy() {
            this.busy = true
            return Promise.resolve()
        },
        hideBusy() {
            this.busy = false
        },
        validate() {
            if (!this.anyTicketsSelected) {
                this.showNoTicketsSelectedAlertAndSetFocus()
                return false
            }

            var invalidTickets = this.ticketsRequiringOtherInventoriesToBeSelected()
            if (invalidTickets.length) {
                const message = `${invalidTickets.join(
                    ', ',
                )} can only be purchased with an additional ticket selection`
                this.showMustPurchaseAdditionalTicketsAlertAndFocus(message)
                return false
            }

            return true
        },

        ticketsRequiringOtherInventoriesToBeSelected() {
            var selectedInventoryIds = this.selectedTickets.map(
                ticket => ticket.inventoryId,
            )

            const ticketRequiresOtherInventoriesToBeSelected = ticket =>
                ticket.requiresAnyOfTheseInventoriesToBeSelected.length &&
                ticket.requiresAnyOfTheseInventoriesToBeSelected.every(
                    inventoryId =>
                        selectedInventoryIds.indexOf(inventoryId) == -1,
                )

            return this.selectedTickets
                .filter(ticketRequiresOtherInventoriesToBeSelected)
                .map(ticket => ticket.name)
        },

        trackCartActions(cartId) {
            var analyticsData = {
                eventName: this.eventName,
                inventory: this.selectedTickets.map(ticket => ({
                    id: ticket.inventoryId,
                    name: ticket.name,
                    quantity: ticket.quantity,
                    price: ticket.price,
                })),
                total: this.total,
                cartId: cartId,
            }

            trackAddToCart(analyticsData)
            trackBeginCheckout(analyticsData)
        },

        submit(event) {
            if (!this.validate()) return

            this.showBusy()
                .then(this.postTickets(event.target.action))
                .then(response => {
                    const { status, redirectUrl, cartId } = response.data

                    if (status === RESERVATION_FAILED_STATUS) {
                        this.handleReservationFailure()
                        return
                    }

                    this.trackCartActions(cartId)
                    this.redirectToPage(redirectUrl)
                })
                .catch(this.handleError)
        },

        postTickets(url) {
            return () =>
                axios.post(url, {
                    accessCodeId: this.accessCode.accessCodeId,
                    accessCode: this.accessCode.accessCode,
                    requestedInventory: this.requestedInventoryToPost,
                })
        },

        addCurrentQuerystringIfAnchorClicked(event) {
            const wasAnAnchorClick =
                event && event.target && event.target.tagName
                    ? event.target.tagName.toLowerCase() === 'a'
                    : false

            if (!wasAnAnchorClick) return false

            const originalHref = event.target.href

            // need to use .event.target.getAttribute('href') rather than event.target.href
            // as event.target.href will always return an absolute url
            var isHrefIsAFragment = (event.target.getAttribute('href') || '').indexOf('#') === 0
            if (isHrefIsAFragment) {
                window.location.href = originalHref
                return
            }

            const currentQuerystring = window.location.search.substring(1)

            if (currentQuerystring === '') {
                window.location.href = originalHref
            } else {
                const originalHrefHasQuerystring =
                    originalHref.indexOf('?') !== -1
                const separator = originalHrefHasQuerystring ? '&' : '?'

                window.location.href =
                    originalHref + separator + currentQuerystring
            }
        },
    },
})



// WEBPACK FOOTER //
// ./Features/Event/index.js